import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Container, Paper, PasswordInput, Text, TextInput, Title } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SwitchControl } from '@/core/components';

import { LoginSchema, loginDefaultValues, loginSchema } from './../model/LoginSchema';
import classes from './Login.module.css';

export interface LoginProps {
  onLogin: (values: LoginSchema) => void;
  isSubmitting: boolean;
}

export function Login({ onLogin, isSubmitting }: LoginProps) {
  const { t } = useTranslation();
  const form = useForm({
    defaultValues: loginDefaultValues,
    resolver: zodResolver(loginSchema),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form;

  return (
    <FormProvider {...form}>
      <Container
        component="form"
        onSubmit={handleSubmit(onLogin)}
        size={420}
        my={0}
      >
        <Title
          ta="center"
          className={classes.title}
        >
          {t('auth.welcomeBack')}
        </Title>
        <Paper
          withBorder
          shadow="xs"
          miw="320px"
          p={30}
          mt={30}
          radius="md"
        >
          <TextInput
            {...register('email')}
            error={errors.email?.message}
            label={t('label.email')}
            placeholder="you@example.com"
            disabled={isSubmitting}
            required
          />
          <PasswordInput
            {...register('password')}
            error={errors.password?.message}
            label={t('label.password')}
            placeholder="*****"
            disabled={isSubmitting}
            required
            mt="md"
            mb="md"
          />
          <SwitchControl
            label={t('auth.useLdapLogin')}
            name="useLdapLogin"
            isSubmitting={isSubmitting}
          />
          {/*<Group justify="space-between" mt="lg">*/}
          {/*  <Anchor component="button" size="sm">*/}
          {/*  TODO  {t('auth.forgotPassword')}*/}
          {/*  </Anchor>*/}
          {/*</Group>*/}
          <Button
            fullWidth
            mt="xl"
            type="submit"
            disabled={isSubmitting}
          >
            {t('auth.login')}
          </Button>
          <Text
            size="sm"
            mt="10px"
          >
            {t('auth.loginDisclaimer')} <a href="mailto:rcci@umfst.ro">rcci@umfst.ro</a>
          </Text>
        </Paper>
        <Text
          mt="10px"
          ta="center"
          size="sm"
        >
          {t('auth.loginResetSsoPassword')}
          &nbsp;
          <a
            target="_blank"
            href="https://user-smartprint.umfst.ro/"
          >
            https://user-smartprint.umfst.ro
          </a>
        </Text>
      </Container>
    </FormProvider>
  );
}
